import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-non-productive-environment',
  templateUrl: './non-productive-environment.component.html',
  styleUrls: ['./non-productive-environment.component.scss']
})
export class NonProductiveEnvironmentComponent {
  isProductionEnvironment: boolean = environment.production; 
}
